import React from 'react';
import type { BaseTypographyProps, BaseTypographyComponent } from './interface';
import MuiTypography from '@mui/material/Typography';
import { getTestId } from '@src/utils/testIds';
import { colorStringToPalette } from '@src/utils/colorStringToPalette/colorStringToPalette';

const BaseTypography: BaseTypographyComponent = (props: BaseTypographyProps) => {
  const { color = 'text.primary', textAlign, children, $web, italic, strikethrough } = props;

  const colorValue = colorStringToPalette(color);
  const sx = {
    textDecoration: strikethrough ? 'line-through' : undefined,
  };

  // If a size is provided, use it. Otherwise check if formatting is
  // explicitly being unset. Fallback on 'inherit' for all other cases.
  const fontSize = props.fontSize ? `${props.fontSize}px` : 'inherit';
  const fontWeight = props.fontWeight ?? 'inherit';
  const fontStyle = italic ? 'italic' : italic === false ? 'normal' : 'inherit';
  const lineHeight = props.lineHeight ? `${props.lineHeight}px` : 'inherit';
  const letterSpacing = props?.letterSpacing ? `${props.letterSpacing}em` : 'inherit';

  return (
    <MuiTypography
      sx={sx}
      color={colorValue}
      component={$web.component}
      fontSize={fontSize}
      fontStyle={fontStyle}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      letterSpacing={letterSpacing}
      textAlign={textAlign}
      data-testid={getTestId(props)}
    >
      {children}
    </MuiTypography>
  );
};

export { BaseTypography };
